export default class emailSettingsWithGaWithoutSender {
    constructor() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                dispatcher: '='
            },
            template: require('../../../../views/maileditor/email-settings-with-ga-without-sender.html'),
            controller: EmailSettingsCtrl,
            controllerAs: 'email'
        }
    }
};

class EmailSettingsCtrl {
    constructor($scope, Setting) {
        this._scope = $scope;

        Setting.findSenderDetail().then((settings) => {
            this.hasGaDomains = settings.google_analytics_domains.length > 0;
        });
        
        this._scope.$on('mailEditor:state:init', () => {
            this.visible = true;
        });
    }
}